export default __webpack_public_path__ + "static/media/pic5.f7bd21c2.jpg";